import _ from 'lodash';
import moment from 'moment';
import formatCurrency from "format-currency";
import createContractModal from "../../../common/modals/createContractModal/createContractModal.component";
import XLSX from 'xlsx';

class ContractsController {
  constructor($rootScope, $http, $state, toastr, $uibModal) {
    "ngInject";
    this.name = "customers";
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.contracts = [];
    let self = this;
    this.newContractName = '';
    this.newContractCustomer = 'none';
    this.customers = [];
    this.$state = $state;
    this.toastr = toastr;
    this.$uibModal = $uibModal;
    this.$http.get($rootScope.apiHost+"/api/admin/customers", {withCredentials: true}).then(function (success) {
      self.customers = success.data;
    });

    this.$http
      .get($rootScope.apiHost + "/api/admin/contracts", {
        withCredentials: true,
      })
      .then(function (success) {
        self.contracts = success.data;
      });



    this.contractFilter = {
      name: '',
      status: 'active'
    }

    this.contractFilterRefresh = false;

    this.contractColumns = [
      {
        displayName: 'Name',
        value: 'name',
        sortable: true,
        dataType: 'text',
        formatting: function (record) {
          return "<a className=\"text-info\" href=\"admin/contracts/"+record.id+"\" >"+record.contractName+"</a>";
        }
      },
      {
        displayName: 'Customer',
        value: 'customer',
        sortable: true,
        sortValue: 'customer',
        dataType: 'text',
        formatting: function (record) {
            return record.customerName;
        }
      },
      {
        displayName: 'Type',
        value: 'type',
        sortable: true,
        sortValue: 'contractClass',
        dataType: 'text',
        formatting: function (record) {
          let classText = '';
          let typeText = '';
          
          // Get contract class
          if (record.contractClass) {
            classText = record.contractClass === 'prime' ? 'Prime Contract' : 'Subcontract';
          } else {
            classText = '(Not Set)';
          }
          
          // Get contract type
          if (record.contractType) {
            typeText = record.contractType;
          } else {
            typeText = '(Not Set)';
          }
          
          // Combine: "Contract Class (Contract Type)"
          return classText + ' (' + typeText + ')';
        }
      },
      {
        displayName: 'Start Date',
        value: 'startDate',
        sortable: true,
        sortValue: 'periodOfPerformance.startDate',
        dataType: 'date',
        formatting: function (record) {
          if (!record.periodsOfPerformance || record.periodsOfPerformance.length === 0) {
            return '(Not Set)';
          }
          
          // Find the earliest start date
          let earliestStart = moment(record.periodsOfPerformance[0].startDate);
          record.periodsOfPerformance.forEach(pop => {
            const popStart = moment(pop.startDate);
            if (popStart.isBefore(earliestStart)) {
              earliestStart = popStart;
            }
          });
          
          return earliestStart.format("MMM, DD, YYYY");
        }
      },
      {
        displayName: 'End Date',
        value: 'endDate',
        sortable: true,
        sortValue: 'periodOfPerformance.endDate',
        dataType: 'date',
        formatting: function (record) {
          if (!record.periodsOfPerformance || record.periodsOfPerformance.length === 0) {
            return '(Not Set)';
          }
          
          // Find the latest end date
          let latestEnd = moment(record.periodsOfPerformance[0].endDate);
          record.periodsOfPerformance.forEach(pop => {
            const popEnd = moment(pop.endDate);
            if (popEnd.isAfter(latestEnd)) {
              latestEnd = popEnd;
            }
          });
          
          return latestEnd.format("MMM, DD, YYYY");
        }
      },
      {
        displayName: 'Time Remaining',
        value: 'timeRemaining',
        sortable: false,
        dataType: 'text',
        formatting: function (record) {
          if (!record.periodsOfPerformance || record.periodsOfPerformance.length === 0) {
            return '(Not Set)';
          }
          
          // Find the latest end date
          let latestEnd = moment(record.periodsOfPerformance[0].endDate);
          record.periodsOfPerformance.forEach(pop => {
            const popEnd = moment(pop.endDate);
            if (popEnd.isAfter(latestEnd)) {
              latestEnd = popEnd;
            }
          });
          
          // Calculate time remaining
          let now = moment();
          
          // If end date is in the past, return expired
          if (latestEnd.isBefore(now)) {
            return 'Expired';
          }
          
          // Calculate difference step by step
          let years = latestEnd.diff(now, 'years');
          let remainingAfterYears = latestEnd.clone().subtract(years, 'years');
          let months = remainingAfterYears.diff(now, 'months');
          let remainingAfterMonths = remainingAfterYears.clone().subtract(months, 'months');
          let days = remainingAfterMonths.diff(now, 'days');
          
          // Build the string
          let parts = [];
          if (years > 0) {
            parts.push(years + ' ' + (years === 1 ? 'year' : 'years'));
          }
          if (months > 0) {
            parts.push(months + ' ' + (months === 1 ? 'month' : 'months'));
          }
          if (days > 0 || parts.length === 0) {
            parts.push(days + ' ' + (days === 1 ? 'day' : 'days'));
          }
          
          return parts.join(', ');
        }
      },
      {
        displayName: 'Recognized Revenue',
        value: 'allTimeRevenue',
        sortable: true,
        sortValue: 'allTimeRevenue',
        dataType: 'number',
        formatting: function (record) {   
          return '$'+formatCurrency(record.allTimeRevenue);
        }
      },
      {
        displayName: 'YTD Revenue',
        value: 'yearlyRevenue',
        sortable: true,
        sortValue: 'yearToDateRevenue',
        dataType: 'number',
        formatting: function (record) {
          return '$'+formatCurrency(record.yearlyRevenue);
        }
      }

    ];


    this.contractFilterCriteria = function () {
      return "name="+self.contractFilter.name+"&status="+self.contractFilter.status;
    }

  }



  formatDate(date) {
    if(date) {
      return moment(date).format("MMM DD, YYYY");
    }

    return '(Not Set)'
  }

  currency(value) {
    let formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });

    return formatter.format(value);
  }

  createContract() {
    let self = this;
    let contract = {
      customerId: this.newContractCustomer.id,
      contractName: this.newContractName
    };

    this.$http.post(this.$rootScope.apiHost+"/api/admin/contracts", contract, {withCredentials: true}).then(function (success) {
      let createdContract = success.data;
      self.toastr.success("Your Contract Was Created Successfully!", "Contract Created");
      self.$state.go("admin.contract-details", {'contractId': createdContract.id} );
    });
  }

  createContractModal() {
    let self = this;
    var modalInstance = this.$uibModal.open(createContractModal);

    modalInstance.success = function (customer, contractName, contractShortName) {

      let contract = {
        contractName: contractName,
        shortName: contractShortName,
        customerId: customer.id
      }

      self.$http.post(self.$rootScope.apiHost+'/api/admin/contracts', contract, { withCredentials: true}).then(function (success) {
        modalInstance.dismiss();
        self.$state.go("admin.contract-details", {'contractId': success.data.id});
        self.toastr.success("Successfully Created Contract", "SUCCESS");
      });
    };

    modalInstance.cancel = function () {
      modalInstance.dismiss();
    };
  }



  filterContracts() {
    this.contractFilterRefresh = true;
  }

}

export default ContractsController;



// WEBPACK FOOTER //
// ./client/pages/admin/contracts/contracts.controller.js